<template>
  <div>
    <!--END NAV SOLO PARA MOBILE-->
    <div class="header_of_header"></div>
    <div class="container2">
      <!--NAV SOLO PARA MOBILE-->
           <div class="row header_mobile">
        <nav class="navbar navbar-expand-lg navbar-light bg-light">
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarNav">
            <ul class="navbar-nav">
              <li class="nav-item active">
                <a class="nav-link" href="#/">
                  Inicio
                  <span class="sr-only"></span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/noticias">Noticias</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/boletines">Boletines</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/imagenes">Imágenes</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#/experiencias">Experiencias</a>
              </li>
            </ul>
          </div>
        </nav>
        <hr />
      </div>
      <div class="row" style="padding:30px">
        <div class="col-md-3">
          <div class="" @click="goToHome()">
            <img src="logo.png" alt="logo" class="" />
          </div>
        </div>
        <div class="col-md-9">
          <div class="row" style="padding-bottom:20px">
            <div class="item-network" v-for="(link, index) in data" :key="index">
              <a :href="link.linkRoute" v-if="link.name === 'Facebook'">
                <img src="facebook.png" alt="facebook" />
              </a>
              <a :href="link.linkRoute" v-if="link.name === 'Instagram'">
                <img src="instagram.png" alt="instagram" />
              </a>
              <a :href="link.linkRoute" v-if="link.name === 'Twitter'">
                <img src="twitter.png" alt="twitter" />
              </a>
              <a :href="link.linkRoute" v-if="link.name === 'Youtube'">
                <img src="youtube.png" alt="youtube" />
              </a>
            </div>
            <div class="search" style="padding-left:10px">
              <SearchExperiences v-model="selected" :experiences="getExperience" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-sm-12 header_nav">
              <router-link v-bind:to="'/'" active-class="active" exact>Inicio</router-link>
              <span class="header_nav_span">|</span>
              <router-link v-bind:to="'/noticias'" active-class="active">Noticias</router-link>
              <span class="header_nav_span">|</span>
              <router-link v-bind:to="'/boletines'" active-class="active">Boletines Agroclimáticos</router-link>
              <span class="header_nav_span">|</span>
              <router-link v-bind:to="'/imagenes'" active-class="active">Imágenes</router-link>
              <span class="header_nav_span">|</span>
              <router-link v-bind:to="'/reportes'" active-class="active">Reportes</router-link>
              <span class="header_nav_span">|</span>
              <router-link v-bind:to="'/experiencias'" active-class="active">Crear Experiencia</router-link>
              <span class="header_nav_span">|</span>
              <router-link
                v-bind:to="'/mitigacion'"
                active-class="active"
              >Mitigación</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import config from "../../../helpers/config";
import { CoolSelect } from "vue-cool-select";
import SearchExperiences from "./searchExperiences";

export default {
  components: { CoolSelect, SearchExperiences },
  data() {
    return {
      data: [],
      selected: "",
      items: []
    };
  },
  watch: {
    selected(value) {
      if (value) {
        this.selectExp(value);
      }
    }
  },
  mounted() {
    this.getLinks();
  },
  methods: {
    goToHome() {
      this.$router.push({ name: "Index" });
    },
    selectExp(name) {
      const found = this.experiences.find(exp => exp.name === name);
      console.log(found);
      if (found) {
        this.$router.push({ name: "DetalleExp", query: { user_id: found.id } });
      }
    },
    async getLinks() {
      const { data } = await Axios.get(`${config.urlApi}/links`);
      this.data = data;
    }
  },
  computed: {
    getExperience() {
      return this.experiences;
    },
    experiences() {
      let exp = this.$store.state.allExperiences;
      console.log(exp.length);
      if (exp.length === 0) {
        exp = JSON.parse(localStorage.getItem("exp"));
      }
      return exp;
    }
  }
};
</script>

<style>
@media (max-width: 768px) {
  .header_desktop {
    display: none !important;
  }
}
@media (min-width: 768px) {
  .header_mobile {
    display: none !important;
  }
}
.header_desktop {
  margin-bottom: 5px !important;
}
.header_of_header {
  height: 10px;
  background-color: #069169;
  color: #069169;
  width: 100%;
}
.header_desktop {
  height: 100px;
  margin-top: 40px;
}
.header_nav,
.header_networks {
}
.header_networks > a {
  margin-left: 5px;
}
.header_networks {
  margin-bottom: 10px;
}
.header_logo {
  text-align: center;
  width: 60%;
  margin-top: -9px;
  margin-left: -15px;
  cursor: pointer;
}
.header_nav > a {
  color: #000;
}
.header_nav_span {
  color: #6699ff;
  padding-left: 10px;
  padding-right: 10px;
}
.img_header_logo {
  width: 200 !important;
  height: 60px;
}
.navbar-nav {
  text-align: center !important;
  margin-left: 130% !important;
  margin-top: -50px !important;
}
@media (max-width: 500px) {
  .navbar-nav {
    margin-left: 100% !important;
  }
}
@media (max-width: 390px) {
  .navbar-nav {
    margin-left: 60% !important;
  }
}
.active {
  color: #007bff !important;
  text-decoration: underline !important;
  background-color: transparent !important;
  font-weight: 800 !important;
}

.none {
  /*display: none;*/
}
.container2 {
  width: 90% !important;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
</style>
